import React from 'react';
import { makeStyles } from '@material-ui/styles';
import WidgetHeader from './WidgetHeader';
import WidgetFooter from './WidgetFooter';
import { widgetSizeEditModalName, widgetsMap } from './WidgetConfig';
import { configureModalMap } from '@topconagriculture/modal';
import { ChangeSizeForm } from './InventoryWidget/ChangeSizeForm/ChangeSizeForm';
const useStyles = makeStyles(() => ({
    widget: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 0 2px 0 rgba(0,0,0,.12), 0 0 2px 0 rgba(0,0,0,.24)',
        borderRadius: 5,
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        zIndex: 1,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        flex: 1,
        overflowY: 'hidden',
    },
}));
configureModalMap({
    [widgetSizeEditModalName]: React.createElement(ChangeSizeForm, null),
});
const Widget = ({ widget }) => {
    const classes = useStyles();
    const WidgetComponent = widgetsMap[widget.type];
    if (!WidgetComponent)
        return null;
    return (React.createElement("div", { className: classes.widget },
        React.createElement(WidgetHeader, { widget: widget }),
        React.createElement("div", { className: classes.content },
            React.createElement(WidgetComponent, { widget: widget })),
        React.createElement(WidgetFooter, { widget: widget })));
};
export default Widget;
//# sourceMappingURL=Widget.js.map